export const PATHS = {
  AUTH: {
    SIGN_IN: "/login",
    SIGN_UP: "/sign-up",
    VERIFY_EMAIL: "/verify",
    SENT_EMAIL: "/sent-email",
    REDIRECTION: "/auth/:provider",
    RESET_PASSWORD: "/reset-password",
  },
  FILE: {
    HOME: "/file/home",
    NEW: "/file/new",
    CONTACTUS: "/file/ContactUs",
    REGULATIONS: "/file/regulations",
    ADVANCEMENT: "/file/advancement/:id",
    DETAILS: "/file/details/:id",
    ADDRESS: "/file/address/:id",
    ACTIONS: "/file/:action/:id",
    CONTACT_US_NOTIFICATION: "/file/ContactUsNotification",
  },
  ACCOUNT: "/account",
  ERROR: "/error",
  PRIVACY_POLICY: "/privacy-policy",
};

export const MOBILE_MAX_WIDTH = 576;
export const MOBILE_MAX_991_WIDTH = 991;

export const REPARATION_REQUEST_STATUS = {
  OPEN: "OPEN",
  CLOSED: "CLOSED",
};
export const FOLDERS_GROUP_BY = {
  PRODUCT: "PRODUCT",
};

export const FOLDER_EXTRA_DATA = {
  WORKFLOW: "WORKFLOW",
  ACTIVE_PROCESS: "ACTIVE_PROCESS",
  INTERVENTION: "INTERVENTION",
};

export const PAGINATION_SIZE = 50;

export const INPUT_ICON_STATES = {
  SIMPLE: "simple",
  VERIFY: "verify",
  LOAD: "load",
  CHECK: "check",
  ERROR: "error",
};

export const STATUS_STATES = {
  WARNING: "warning",
  DANGER: "danger",
};

export const DOC_TYPES = {
  HTML: "HTML",
  PDF: "PDF",
};

export const ACTIONS_KEY = {
  ADVANCEMENT: "advancement",
  DETAILS: "details",
  DOCUMENTS: "documents",
  HISTORY: "history",
  MESSAGES: "messages",
  ADDRESS: "address",
};
